<div class="flex items-center justify-center">
  <div class="text-center p-8">
    <div *ngIf="selectedEnterprise === null">
      <h1 class="text-3xl font-bold mb-8 text-white">Select Enterprise</h1>
      <div class="grid grid-cols-5 justify-center gap-8">
        <!-- Check if enterprises array has elements -->
        <ng-container *ngIf="enterprises.length > 0; else loading">
          <!-- Iterate over enterprises -->
          <div
            *ngFor="let enterprise of enterprises; let i = index"
            class="bg-white rounded-lg shadow-md p-6 text-center w-64 h-48 hover:cursor-pointer space-y-10"
            (click)="handleEnterpriseClick(enterprise)"
          >
            <img
              [src]="enterprise.corpBranding?.images[0]?.imageUrl || '../../assets/images/enterprise_placeholder_logos.svg'"
              [alt]="enterprise.name + ' logo'"
              class="max-w-full max-h-12 mx-auto mb-4 object-contain"
            />
            <h2 class="text-lg font-semibold mb-2">{{ enterprise.name }}</h2>
          </div>
        </ng-container>

        <!-- Loading Skeletons -->
        <ng-template #loading>
          <div class="flex justify-center items-center col-span-5">
            <div class="grid grid-cols-5 gap-8">
              <!-- Repeat Skeleton 5 times -->
              <div
                *ngFor="let placeholder of [1,2,3,4,5]"
                class="bg-gray-300 rounded-lg animate-pulse w-64 h-48"
              ></div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div *ngIf="selectedEnterprise!==null">
      <h1 class="text-3xl font-bold mb-8 text-white">Select Location</h1>
      <div class="grid grid-cols-5 justify-center gap-8">
        <!-- Check if locations array has elements -->
        <ng-container *ngIf="locations.length > 0; else loading">
          <!-- Iterate over locations -->
          <div
            *ngFor="let location of locations; let i = index"
            class="bg-white rounded-lg shadow-md p-6 text-center w-64 h-48 hover:cursor-pointer space-y-10"
            (click)="handleLocationClick(location)"
          >
            <img
              [src]="selectedEnterprise.corpBranding?.images[0]?.imageUrl || '../../assets/images/enterprise_placeholder_logo.svg'"
              [alt]="location.name + ' logo'"
              class="max-w-full max-h-12 mx-auto mb-4 object-contain"
            />
            <h2 class="text-lg font-semibold mb-2">{{ location.name }}</h2>
          </div>
        </ng-container>

        <!-- Loading Skeletons -->
        <ng-template #loading>
          <div class="flex justify-center items-center col-span-5">
            <div class="grid grid-cols-5 gap-8">
              <!-- Repeat Skeleton 5 times -->
              <div
                *ngFor="let placeholder of [1,2,3,4,5]"
                class="bg-gray-300 rounded-lg animate-pulse w-64 h-48"
              ></div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
